<template>
  <v-btn
    class="go-back-btn"
    @click="goBack"
    flat
  >
    <v-icon start class="back-icon">mdi-arrow-left</v-icon>
    {{ ButtonText }}
  </v-btn>
</template>

<script>
export default {
  name: "BackButton",
  methods: {
    goBack() {
      this.$emit('OnButtonClicked');
      this.$router.back();
    }
  },
  emits: ['OnButtonClicked'],
  props: {
    ButtonText: {
      type: String,
      default: "Go Back"
    }
  }
}
</script>

<style scoped>
.go-back-btn {
  background-color: #2b3b43;
  color: #fff;
  border-radius: 12px;
  padding: 10px 20px;
  font-weight: 600;
  font-size: 0.95rem;
  text-transform: none;
  transition: background-color 0.3s;
}

.go-back-btn:hover {
  background-color: #34454d;
}

.back-icon {
  color: var(--duallo-accent);
  font-size: 1.2rem;
}
</style>
